// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"57cbbcb3","405":"6792e453","606":"5964d870","731":"7016348e","863":"e73a979b","896":"d34eca19","927":"78f7d054"}[chunkId] + ".css";
};